import React from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";

class CopyModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configuration: {},
      configName: "",
      isSaving: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  async componentWillReceiveProps(nextProps) {
    this.setState({
      configName: "",
      ...nextProps,
    });
  }

  async onSave() {
    this.setState({
      ...this.state,
      isSaving: true,
    });
    await this.props.onSave(this.state);
    this.setState({
      ...this.state,
      isSaving: false,
    });
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-lg">
            Copy Configuration: {this.state.configuration.name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container-fluid">
            <div className="form-group">
              <label>New Config Name</label>
              <input
                id="configName"
                className="form-control"
                type="text"
                placeholder="Config Name"
                value={this.state.configName}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="btn btn-primary pull-right"
            style={{ marginLeft: 10 }}
            onClick={() => {
              this.onSave();
            }}
          >
            Save
            {this.state.isSaving ? (
              <span>
                <i className="fa fa-spinner fa-spin" />
              </span>
            ) : (
              <span></span>
            )}
          </Button>
          <Button className="btn btn-secondary" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect()(CopyModal);
